import { CheckOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import React from 'react';
import { botMessagesTypes } from '@guuru/chat-web';
import { i18n } from '@guuru/translation-web';
import ChatRenderText from '../../Text';
import { Contacts } from './style';

const { Text } = Typography;

interface ContactsSubmitedProps {
  readOnly?: boolean;
  phone?: string;
  email?: string;
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    metadata: {
      contacts: {
        phone?: string;
        email?: string;
      };
    };
  };
}

const ContactsSubmited = function ({
  message,
  readOnly = false,
  phone,
  email,
}: ContactsSubmitedProps) {
  const { smartFormStyle = false } = message;

  const renderContactInformation = function () {
    const { contacts = {} } = message?.metadata || {};
    contacts.phone = phone;
    contacts.email = email;
    return (
      <Contacts orientation="vertical" size={4}>
        {['email', 'phone']
          .filter((type) => contacts[type as keyof typeof contacts])
          .map((type) => (
            <Space key={type} size={6} align="center">
              {type === 'email' ? <MailOutlined /> : <PhoneOutlined />}
              <Text ellipsis>{contacts[type as keyof typeof contacts]}</Text>
              <CheckOutlined />
            </Space>
          ))}
      </Contacts>
    );
  };

  let confirmedMessage;
  if (readOnly) {
    confirmedMessage = message.text;
  } else {
    confirmedMessage = smartFormStyle
      ? i18n.t(botMessagesTypes.requestSentSmartForm)
      : i18n.t(botMessagesTypes.transferContactInformationConfirmed);
  }
  return (
    <ChatRenderText
      message={{ ...message, i18n: confirmedMessage! }}
      note={smartFormStyle}
      tooltip={!smartFormStyle}
    >
      {!readOnly && renderContactInformation()}
    </ChatRenderText>
  );
};

export default ContactsSubmited;
